var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1695025288596,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 729,
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M621.093184 219.292365l204.494898-118.227188a78.697356 78.697356 0 0 1 86.172365 1.22041C957.773706 131.89959 1008.401639 158.271881 1008.401639 158.271881l-245.130727 144.523203zM618.900261 506.79419L761.802607 425.236499l246.846927 142.654451-112.220484 66.455121s-30.681862 22.158063-93.72365-19.068902-183.80514-108.48298-183.805139-108.482979zM435.476499 613.122384l77.419739-43.820336 76.676053 44.926332-19.354935 376.820559-58.064805 32.512476-57.683426-33.599404-18.992626-376.839627zM13.424507 158.500708l355.425251 204.97162s52.077169 23.016164 78.888045 53.145028c24.961192 28.050354-11.689236 75.017058-11.689237 75.017057l219.063538-129.668528L186.760819 91.301899S152.665624 74.368715 101.065177 105.908678 13.424507 158.500708 13.424507 158.500708z",
    fill: "#49B95A",
    "p-id": 730
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.44581 568.253259l115.957989 65.501676a6.521564 6.521564 0 0 0 0.896238 0.438585c4.481192 1.90689 38.976834 15.159777 79.822421-14.339814 41.799032-30.186071 207.622197-119.275978 222.839181-127.437468a9.381899 9.381899 0 0 0 2.154786-1.582718c6.807598-6.731322 45.574674-49.045214-2.669647-88.403427-0.572067-0.457654-3.051024-2.822197-3.81378-2.917542l-21.357169-14.110987-14.663985-8.962383-20.975792-10.983688c-2.917542-1.620857-6.483426 0.305102-9.381899 1.906891z",
    fill: "#259247",
    "p-id": 731
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M647.103166 84.589646L507.976462 1.697132l-138.745326 83.254823 139.107635 81.805587 138.764395-82.167896z",
    fill: "#49B95A",
    "p-id": 732
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df5e3c6ecc5aa65c6f69cc00232a1b62.svg";
export { ForwardRef as ReactComponent };